<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import TagMultiSelectComboBox from 'dashboard/components-next/combobox/TagMultiSelectComboBox.vue';

const props = defineProps({
  catalog: { type: Object, default: () => ({}) },
  responsavelVendedor: { type: String, default: '' },
  responsavelComprador: { type: String, default: '' },
  pendenciaTaxa: { type: Array, default: () => [] },
});

const emit = defineEmits([
  'update:responsavelVendedor',
  'update:responsavelComprador',
  'update:pendenciaTaxa',
]);

const { t } = useI18n();
const sellerOptions = computed(() =>
  (props.catalog.sellers || []).map(party => ({
    value: party.id.toString(),
    label: party.name,
  }))
);
const buyerOptions = computed(() =>
  (props.catalog.buyers || []).map(party => ({
    value: party.id.toString(),
    label: party.name,
  }))
);
const taxOptions = computed(() =>
  (props.catalog.tax_types || []).map(type => ({
    value: type.id,
    label: type.label,
  }))
);
</script>

<template>
  <div class="grid gap-5">
    <section class="grid gap-4">
      <div>
        <h2 class="text-lg font-semibold text-lais-text">
          {{ t('POST_SALE.FORM.TAXES.PARTIES_TITLE') }}
        </h2>
        <p class="mt-1 text-sm text-lais-text-body">
          {{ t('POST_SALE.FORM.TAXES.PARTIES_DESCRIPTION') }}
        </p>
      </div>
      <div class="grid gap-4 sm:grid-cols-2">
        <label class="grid gap-1 text-sm font-semibold text-lais-text-body">
          {{ t('POST_SALE.FORM.SELLER_RESPONSIBLE') }}
          <select
            :value="responsavelVendedor"
            class="min-h-10 rounded-lais border border-lais-border bg-white px-2 font-normal"
            @change="emit('update:responsavelVendedor', $event.target.value)"
          >
            <option value="">{{ t('POST_SALE.FORM.SELECT') }}</option>
            <option
              v-for="option in sellerOptions"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </label>
        <label class="grid gap-1 text-sm font-semibold text-lais-text-body">
          {{ t('POST_SALE.FORM.BUYER_RESPONSIBLE') }}
          <select
            :value="responsavelComprador"
            class="min-h-10 rounded-lais border border-lais-border bg-white px-2 font-normal"
            @change="emit('update:responsavelComprador', $event.target.value)"
          >
            <option value="">{{ t('POST_SALE.FORM.SELECT') }}</option>
            <option
              v-for="option in buyerOptions"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </label>
      </div>
    </section>

    <section class="grid gap-4">
      <h2 class="text-lg font-semibold text-lais-text">
        {{ t('POST_SALE.FORM.TAXES.PROPERTY_TITLE') }}
      </h2>
      <label class="grid gap-1 text-sm font-semibold text-lais-text-body">
        {{ t('POST_SALE.FORM.TAXES.MUNICIPAL_REGISTRATION') }}
        <input
          :value="catalog.property?.municipal_registration || ''"
          class="min-h-10 rounded-lais border border-lais-border bg-lais-bg-soft px-2 font-normal"
          readonly
        />
      </label>
      <label class="grid gap-1 text-sm font-semibold text-lais-text-body">
        {{ t('POST_SALE.FORM.TAX_PENDING') }}
        <span class="text-xs font-normal text-lais-text-muted">
          {{ t('POST_SALE.FORM.TAXES.PENDING_MENU') }}
        </span>
        <TagMultiSelectComboBox
          :model-value="pendenciaTaxa"
          :options="taxOptions"
          :placeholder="t('POST_SALE.FORM.SELECT')"
          @update:model-value="emit('update:pendenciaTaxa', $event)"
        />
      </label>
    </section>
  </div>
</template>
